export const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';